import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {ARService} from '../../ar.service';
import {DatePipe} from '@angular/common';
import {NoteDataModel} from '../../../../models/notes/note-data.model';
import {TdoNoteAssociatedObject, TdoNoteSaveModel} from '../../../../main-interface/controls/tdo-notes/models/tdo-note-save-model';
import {MessagingConstants} from '../../../../models/MessagingConstants';
import {NotesService} from '../../../../services/notes.service';
import {MessagingService} from '../../../../services/messaging.service';
import {CaseFinalReportSelectComponent} from '../../../case-forms/case-final-report-select/case-final-report-select.component';
import {DataARClaimNarrativeAttachmentModel} from '../../models/data-ar-claim-narrative-attachment.model';

@Component({
  selector: 'app-narrative-note-dialog',
  templateUrl: './narrative-note-dialog.component.html',
  styleUrls: ['./narrative-note-dialog.component.scss']
})
export class NarrativeNoteDialogComponent implements OnInit {

  ARClaimID: string;
  patientId: string;
  // notes: NoteDataModel[] = [];
  attachments: DataARClaimNarrativeAttachmentModel[];
  noteText: string = '';
  enumClaimAttachmentStatusAdded: string = '00000541-1000-0000-0000-000000000001';
  enumClaimAttachmentStatusSent: string = '00000541-1000-0000-0000-000000000002';
  enumClaimAttachmentTypeDocument: string = '00000542-1000-0000-0000-000000000001';
  enumClaimAttachmentTypeNarrative: string = '00000542-1000-0000-0000-000000000002';
  note: NoteDataModel;

  constructor(
    public dialogRef: MatDialogRef<NarrativeNoteDialogComponent>,
    private dialog: MatDialog,
    private arService: ARService,
    private datePipe: DatePipe,
    public noteService: NotesService,
    private messagingService: MessagingService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  async ngOnInit() {

    this.patientId = this.data.PatientId;
    this.ARClaimID = this.data.ARClaimID;

    // if claimid exists, load rest of component
    if (this.ARClaimID) {

      // get narrative notes
      const promises: any[] = [
        this.arService.getNarrativeAttachementForClaim(this.ARClaimID).toPromise(),
      ];

      const results: any[] = await Promise.all(promises);
      this.attachments = results[0];
    }
  }

  onCancelClick() {
    this.dialogRef.close(true);
  }

  onOkClick() {
    // this.dialogRef.close(this.selectedImages);
  }

  onNarrativeOkClick() {
    this.createNote();
  }

  createNote() {
    const noteModel = new TdoNoteSaveModel();
    noteModel.associatedObjects = [];
    const as1 = new TdoNoteAssociatedObject();
    as1.parentObjectName = 'dataARClaims';
    as1.objectId = this.ARClaimID;
    noteModel.associatedObjects.push(as1);
    noteModel.text = this.noteText;

    noteModel.patientId = this.patientId;
    this.noteService.saveNote(noteModel).subscribe((res) => {
      this.messagingService.sendComponentMessage(MessagingConstants.NOTES_REFRESH, '');
      const newNote: NoteDataModel = res;
      this.noteText = '';

      // create claim attachment record with new noteid
      this.arService.saveClaimNarrativeAttachment(this.ARClaimID, newNote).subscribe((resNarrative) => {
        const newNarrativeAttachment: DataARClaimNarrativeAttachmentModel = resNarrative;
        this.attachments.push(newNarrativeAttachment);
      });
    });
  }

  claimNarrativeNoteStatus(narrative: DataARClaimNarrativeAttachmentModel) {
    let returnStatus: string = 'No Status';
    if (narrative.enumClaimAttachmentStatusID === this.enumClaimAttachmentStatusSent) {
      returnStatus = 'Narrative Sent @' + this.datePipe.transform(narrative.StatusOn, 'dd-MM-yyyy');
    }
    else if (narrative.enumClaimAttachmentStatusID === this.enumClaimAttachmentStatusAdded) {
      returnStatus = 'Narrative Added @' + this.datePipe.transform(narrative.StatusOn, 'dd-MM-yyyy');
    }
    return returnStatus;
  }

  claimNarrativeNoteStatusCode(narrative: DataARClaimNarrativeAttachmentModel) {
    let returnStatus: string = '';
    if (narrative.enumClaimAttachmentStatusID === this.enumClaimAttachmentStatusSent) {
      returnStatus = 'sent';
    }
    else if (narrative.enumClaimAttachmentStatusID === this.enumClaimAttachmentStatusAdded) {
      returnStatus = 'added';
    }
    return returnStatus;
  }

  deleteNarrativeNote(narrative: DataARClaimNarrativeAttachmentModel) {
    // delete claim narrative attachment
    this.arService.deleteClaimNarrativeAttachment(this.ARClaimID, narrative.NoteID).subscribe((resNarrative) => {
      const result = resNarrative;
      if (result === 1) {
        this.attachments = this.attachments.filter(a => a.ClaimAttchID !== narrative.ClaimAttchID);
      }
    });
  }

  onFRNoteClick() {
    this.openCaseFinalReportPicker();
  }

  openCaseFinalReportPicker() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'dialog';
    dialogConfig.data = {
      PatientId: this.patientId
    };

    const dialogRef = this.dialog.open(CaseFinalReportSelectComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        this.noteText = result.Note;
      }
    }, err => {
    });
  }
}

